export interface UnitsState {
  preferences: SettingsPreferences;
  setLoading: boolean;
  getLoading: boolean;
}

export enum SettingsPreference {
  Notifications = 'notifications',
  Temperature = 'temperature',
  FlowRate = 'flowRate',
  Volume = 'volume',
  Pressure = 'pressure',
}

export enum SettingsPreferenceOption {
  On = 'on',
  Off = 'off',
  Celsius = 'celsius',
  Fahrenheit = 'fahrenheit',
  LiterPerHour = 'literPerHour',
  GallonPerMinute = 'gallonPerMinute',
  CubicMeter = 'cubicMeter',
  CubicFeet = 'cubicFeet',
  Bar = 'bar',
  PoundPerSquareInch = 'poundPerSquareInch',
}

export interface SettingsPreferences {
  notifications: 'on' | 'off';
  temperature: 'celsius' | 'fahrenheit';
  flowRate: 'literPerHour' | 'gallonPerMinute';
  volume: 'cubicMeter' | 'cubicFeet';
  pressure: 'bar' | 'poundPerSquareInch';
}
